// Read-only import from the earlier device-only version. New answers are never
// written here, and a cloud answer (including a reset) always takes precedence.
const DATABASE = 'instil-iq-answers';
const STORE = 'answers';
let databasePromise;
function openDatabase() {
    if (!window.indexedDB) return Promise.resolve(null);
    if (!databasePromise) databasePromise = new Promise((resolve, reject) => {
        const request = window.indexedDB.open(DATABASE, 1);
        let absent = false;
        const timeout = setTimeout(() => reject(new Error('Previous answer storage is busy')), 4000);
        // Opening a missing database normally creates one. Abort that upgrade:
        // students without old device answers do not need a local answer store.
        request.onupgradeneeded = () => {absent = true; request.transaction.abort();};
        request.onsuccess = () => {
            clearTimeout(timeout); const db = request.result;
            db.onversionchange = () => {db.close(); databasePromise = null;}; resolve(db);
        };
        request.onerror = () => {clearTimeout(timeout); if (absent) resolve(null); else reject(request.error);};
        request.onblocked = () => {clearTimeout(timeout); reject(new Error('Previous answer storage is busy'));};
    }).catch(error => {databasePromise = null; throw error;});
    return databasePromise;
}
async function readDatabase(scope, questionId) {
    const db = await openDatabase();
    if (!db) return null;
    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE, 'readonly');
        const request = transaction.objectStore(STORE).get(JSON.stringify([scope, questionId]));
        transaction.oncomplete = () => resolve(request.result || null);
        transaction.onabort = () => reject(transaction.error || new Error('Could not import previous answer'));
        transaction.onerror = () => reject(transaction.error || new Error('Could not import previous answer'));
    });
}
export async function readLegacyDraft(scope, questionId) {
    const stored = await readDatabase(scope, questionId);
    const recovered = JSON.parse(window.localStorage.getItem(`instil-iq-answer:v1:${encodeURIComponent(scope)}:${encodeURIComponent(questionId)}`));
    let latest = null;
    for (const record of [stored, recovered]) {
        if (!record) continue;
        if (record.version !== 1 || record.scope !== scope || record.questionId !== questionId || !Number.isFinite(record.updatedAt) || !Number.isInteger(record.epoch) || record.epoch < 0) throw new Error('Could not import previous answer');
        if (!latest || record.updatedAt >= latest.updatedAt) latest = record;
    }
    return latest;
}
